export default __webpack_public_path__ + "static/media/redRootSVGLOGO.dcabb132.svg";